import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import DynamicForm from "@/common/DynamicForm";
import { IntakeSectionHeader } from "@/common/styles";
import { Col, Row } from "antd";
import { FormContainer } from "../InmateDetails/styles";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import {
  getOptionsFromRefList,
  isNonEmptyVariable,
  hasCheckSecurity,
} from "@/util/common_function";
import { useSelector } from "react-redux";
import { FieldSecurityProvider } from "@/contexts/FieldSecurityContext";
import SecureFormItem from "@/common/SecureFormItem";
import { SCHEMA_NAME } from "@/util/common_variable";

const OriginalChargeInformation = ({
  originalChargeDescriptionID,
  startingPoint = "",
  form,
  chargesExtraFields = [],
}) => {
  const { bookingsFieldsEnabled } = useSelector(
    (state) => state?.bookings
  );

  const checkCount = (_, value) => {
    if (value > 0 && value <= 10000) {
      return Promise.resolve();
    }
    return Promise.reject(
      new Error("Count must be greater than 0 and less than 10000")
    );
  };

  const fullSearch = useSelector((state) => state.fullSearch);

  return (
    <FieldSecurityProvider
      entity={SCHEMA_NAME.CHARGES}
      startingPoint={startingPoint}
      bookingsFieldsEnabled={bookingsFieldsEnabled}
    >
      <>
        <IntakeSectionHeader>
          <span>Original Charge Information</span>
        </IntakeSectionHeader>

        <FormContainer>
          <Row gutter={16}>
            <Col span={18}>
              <SecureFormItem
                fieldName="originalChargeDescriptionID"
                formItemProps={{
                  name: "originalChargeDescriptionID",
                  label: "Charge",
                  layout: "vertical",
                }}
              >
                <Select
                  options={getOptionsFromRefList(
                    "Charges",
                    false,
                    false,
                    true
                  )}
                  placeholder="Charge"
                  showSearch
                  variant="outlined"
                  isSelectedValueFocus
                />
              </SecureFormItem>
            </Col>

            <Col span={6}>
              <SecureFormItem
                fieldName="originalUCRCode"
                formItemProps={{
                  name: "originalUCRCode",
                  label: "Code",
                  layout: "vertical",
                }}
                overrideDisabled={true}
              >
                <TextField />
              </SecureFormItem>
            </Col>

            <Col span={6}>
              <SecureFormItem
                fieldName="originalChargeLevelID"
                formItemProps={{
                  name: "originalChargeLevelID",
                  label: "Level",
                  layout: "vertical",
                }}
              >
                <Select
                  options={getOptionsFromRefList(
                    "Charge_Level",
                    false,
                    false,
                    true
                  )}
                  placeholder="Level"
                  showSearch={false}
                  variant="outlined"
                />
              </SecureFormItem>
            </Col>

            <Col span={6}>
              <SecureFormItem
                fieldName="originalChargeCount"
                formItemProps={{
                  name: "originalChargeCount",
                  label: "Count",
                  layout: "vertical",
                  rules: !fullSearch
                    ? isNonEmptyVariable(originalChargeDescriptionID)
                      ? [
                          {
                            validator: checkCount,
                          },
                        ]
                      : null
                    : null,
                }}
              >
                <TextField type="number" />
              </SecureFormItem>
            </Col>
          </Row>

          {/* ChargesExtra dynamic fields — real per-client columns (Legacy
              Offense, Bail Set By, Bail Set Date, Indictment Number,
              Responsible Investigator Name/Phone, ...), fetched live and
              fetched/saved via the generic /api/extra endpoints, same as
              BioExtra/ArrestReportsExtra/InmatePropertyExtra. */}
          {chargesExtraFields.length > 0 && (
            <>
              <IntakeSectionHeader>
                <span>Agency-Specific Information</span>
              </IntakeSectionHeader>

              <Row gutter={16}>
                {chargesExtraFields.map((sf, index) => {
                  const view = hasCheckSecurity(
                    "Functionality", "field", "VIEW", "", "",
                    "ChargesExtra", sf.columnName, startingPoint,
                  );
                  const edit = hasCheckSecurity(
                    "Functionality", "field", "MODIFY", "", "",
                    "ChargesExtra", sf.columnName, startingPoint,
                  );
                  return (
                    <DynamicForm
                      key={index}
                      formAttributes={sf}
                      form={form}
                      bookingsFieldsEnabled={bookingsFieldsEnabled}
                      fullSearch={fullSearch}
                      view={view}
                      edit={edit}
                    />
                  );
                })}
              </Row>
            </>
          )}
        </FormContainer>
      </>
    </FieldSecurityProvider>
  );
};

export default OriginalChargeInformation;